import { Page } from "v2/components";

import { CollaboratorsSummary } from "./CollaboratorsSummary";
import { CollaboratorsTotal } from "./CollaboratorsTotal";
import { CarteirinhasTab } from "./CarteirinhasTab/CarteirinhasTab";
import { CollaboratorsElegible } from "./CollaboratorsElegible";
import { CollaboratorsMovements } from "./CollaboratorsMovements";

export function Collaborators() {
  return (
    <Page title="Colaboradores">
      <Page.Tab name="Resumo" variant="free">
        <CollaboratorsSummary />
      </Page.Tab>
      <Page.Tab name="Cadastro">
        <CollaboratorsTotal />
      </Page.Tab>
      <Page.Tab name="Carteirinhas">
        <CarteirinhasTab />
      </Page.Tab>
      {/* <Page.Tab name="Elegíveis" disabled>
        <CollaboratorsElegible />
      </Page.Tab>
      <Page.Tab name="Massa Movimentada" disabled>
        <CollaboratorsMovements />
      </Page.Tab> */}
    </Page>
  );
}
